export enum InvitationType {
  Pass = "Pass",
  TwoStepMembership = "TwoStepMembership",
  Coupon = "Coupon",
}

export const InvitationTypeList = () =>
  Object.entries(InvitationType).map(([label, value]) => {
    return { label, value };
  });
